import React from "react";

const PromptDark = () => {
  return (
    <svg
      width="208"
      height="224"
      viewBox="0 0 208 224"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Chippy Dark Icon</title>
      <rect
        y="143.402"
        width="175.681"
        height="124.11"
        rx="11.3343"
        transform="rotate(-50 0 143.402)"
        fill="#232323"
      />
      <path
        d="M140.601 96.1379L134.187 95.5763C131.195 95.3144 128.557 97.5379 128.295 100.529C125.682 130.378 99.3574 152.564 69.5091 149.95C39.6608 147.337 17.5823 121.022 20.1954 91.1739L21.0798 81.0721M50.3041 88.2327L49.7894 94.1118C48.5986 107.714 58.9279 119.657 72.5493 120.602C85.8651 121.526 97.6272 111.699 98.9318 98.4152L100.017 87.3677M103.585 51.0357L103.865 48.1845C105.948 26.975 90.3173 8.1442 69.087 6.28555L67.5846 6.15403C45.6908 4.2373 26.3887 20.4319 24.4719 42.3256L24.279 44.5292"
        stroke="#E1E1E1"
        strokeWidth="11.4465"
        strokeLinecap="round"
      />
      <path
        d="M85.1031 67.9931C85.9243 58.6133 94.2313 51.6417 103.698 52.4705C113.166 53.2994 120.135 61.6083 119.314 70.9881C118.493 80.368 110.186 87.3395 100.718 86.5107C91.2512 85.6819 84.282 77.3729 85.1031 67.9931Z"
        stroke="#E1E1E1"
        strokeWidth="11.4465"
      />
      <path
        d="M5.79209 61.0517C6.61326 51.6719 14.9203 44.7003 24.3874 45.5291C33.8546 46.3579 40.8239 54.6669 40.0027 64.0467C39.1816 73.4265 30.8745 80.3981 21.4074 79.5693C11.9402 78.7405 4.97092 70.4315 5.79209 61.0517Z"
        stroke="#E1E1E1"
        strokeWidth="11.4465"
      />
      <path
        d="M39.1764 29.6266C28.0694 26.6407 17.5776 24.6251 6.93346 29.9523"
        stroke="#E1E1E1"
        strokeWidth="11.4465"
        strokeLinecap="round"
      />
      <path
        d="M91.9109 34.2427C103.368 33.2322 114.05 33.0703 123.607 40.166"
        stroke="#E1E1E1"
        strokeWidth="11.4465"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default PromptDark;
